export default {
    encode: (s) => {
      return btoa(s)
    },
    decode: (s) => {
      return atob(s)
    }
  }
  


// WEBPACK FOOTER //
// ./src/config/base64/index.js